import React, {useState, useEffect, useRef, useContext} from 'react';
import GoBack from "../components/goBack";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import OrgContext from "../organisation/OrgContext";
import {API, baseURL} from "../services/api";
import Swal from "sweetalert2";
import {useParams} from "react-router";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import axios from "axios";

const SingleModele = () => {
    const {organisation, changeOrg} = useContext(OrgContext);
    const [isNotValid, setIsNotValid] = useState('');
    const nameInputRef = useRef('');
    const objetInputRef = useRef('');
    const contentInput = useRef('');
    const emailModelType = useRef('');

    const [name, setName] = useState('');
    const [objet, setObjet] = useState('');
    const [content, setContent] = useState('');
    const [type, setType] = useState('');


    const {id} = useParams();
    const [t, i18n] = useTranslation();
    const navigate = useNavigate();
    const [modele, setModele] = useState([]);

    let allRequiredInputsAreValid = true;
    useEffect(() => {
        getSingleModel();
    }, []);
    const getSingleModel = async () => {
        await axios
            .get(baseURL + `/modele/${id}`)
            .then((response) => {
                setName(response.data.data.name);
                setObjet(response.data.data.objet);
                setContent(response.data.data.content);
                setType(response.data.data.type);
            })
            .catch((error) => console.log("error while retrieving data : " + error))
    }
    const Save = () => {
        if (checkRequiredInputs()) {
            const preparedObject = {
                type: emailModelType.current.value,
                name: nameInputRef.current.value,
                content: contentInput.current.value,
                organization_id: organisation.id,
                objet: objetInputRef.current.value
            };
            updateModele(preparedObject);
        }
    }
    const updateModele = async (modele) => {
        const response = await API.patch(`/modele/${id}`, modele).then(res => {
            console.log(res);
            Swal.fire(
                t('Le modele d\'email a été enregistrée avec succès'),
                t(''),
                'success'
            );
            navigate('/modeles')
        }).catch((error) => console.log(error));
    }
    const checkRequiredInputs = () => {
        if (nameInputRef.current.value.length <= 0) {
            isInvalidDomElement("nomInput");
            allRequiredInputsAreValid = false;
        } else {
            isaValidDomElement("nomInput");
        }

        if (objetInputRef.current.value.length <= 0) {
            isInvalidDomElement("objetInput");
            allRequiredInputsAreValid = false;
        } else {
            isaValidDomElement("objetInput");
        }

        if (contentInput.current.value.length <= 0) {
            isInvalidDomElement("contentInput");
            allRequiredInputsAreValid = false;
        } else {
            isaValidDomElement("contentInput");
        }

        return allRequiredInputsAreValid;
    }
    const isInvalidDomElement = (elementId) => {
        const nomInput = document.getElementById(elementId);
        nomInput.classList.add("is-invalid");
    }
    const isaValidDomElement = (elementId) => {
        const nomInput = document.getElementById(elementId);
        nomInput.classList.remove("is-invalid");
        nomInput.classList.add("is-valid");
    }

    return (
        <>
            <div className="main-container container-fluid">
                <GoBack route='/modeles'/>
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">Modele d'email</div>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="requiredElt">Nom du modèle*</label>
                                <input type="text" className={`form-control ${isNotValid}`} id="nomInput" placeholder=""
                                       ref={nameInputRef} value={name}
                                       onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="requiredElt">Objet*</label>
                                <input type="text" className={`form-control ${isNotValid}`} id="objetInput"
                                       placeholder=""
                                       ref={objetInputRef} value={objet}
                                       onChange={(e) => setObjet(e.target.value)}
                                />
                            </div>
                            <div className="form-group"><label className="form-label requiredElt">Contenu*</label>
                                <ReactQuill id="contentInput" className={`form-control ${isNotValid}`} theme="snow"
                                            value={content}
                                            ref={contentInput}/>
                            </div>
                            <input type="hidden" ref={emailModelType} value={type}
                                   onChange={(e) => setType(e.target.value)}/>
                        </div>
                        <div className="card-footer">
                            <div className="row">

                                <div className="col-md-12">
                                    <a href="javascript:void(0)" className="btn btn-primary"
                                       onClick={Save}>Enregistrer</a>
                                    <a 
                                        onClick={()=>{
                                            navigate(-1);
                                        }}
                                    className="btn btn-default float-end">Annuler</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default SingleModele;